
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Monthlypickanddropservice() {



    const cardData =
    {
        keyword: 'Monthly Pick and Drop Service Pune  ',
        heading: 'etravo : Monthly Pick and Drop Service Pune ',



"headingDescription": "eTravo offers reliable Monthly Pick and Drop Service in Pune, designed for employees, corporate teams, and professionals seeking safe and punctual daily commuting solutions. With well-maintained vehicles, trained drivers, and GPS-enabled tracking, eTravo ensures hassle-free office transportation across Pune. Flexible monthly plans, customized routes, and on-time service make it an ideal choice for IT companies, businesses, and working professionals.",

"top": "Top Areas for Monthly Pick and Drop Service in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "One of Pune’s largest IT hubs, Hinjewadi sees heavy daily commuter traffic, making it a key location for organized monthly employee transport services."
  },
  {
    "title": "Kharadi IT Park",
    "description": "Home to major IT companies and corporate offices, Kharadi requires reliable pick and drop services for thousands of working professionals."
  },
  {
    "title": "Magarpatta City",
    "description": "A major business township with Cybercity, making it a prime location for structured employee commute and monthly cab services."
  },
  {
    "title": "Hadapsar",
    "description": "A busy commercial and IT zone where daily office commuting demands efficient and punctual transportation solutions."
  },
  {
    "title": "Baner",
    "description": "A growing business and residential hub with many professionals requiring daily office pick and drop services."
  },
  {
    "title": "Wakad",
    "description": "Closely connected to Hinjewadi, Wakad is a popular residential area for IT employees needing regular commute services."
  },
  {
    "title": "Viman Nagar",
    "description": "A corporate and residential hotspot near the airport, ideal for professionals looking for reliable monthly transportation."
  },
  {
    "title": "Koregaon Park",
    "description": "A premium locality with offices and business centers, where professionals prefer comfortable daily commute options."
  },
  {
    "title": "Shivajinagar",
    "description": "A central business district with offices and institutions, making it a key pickup and drop point for employees."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "An industrial and corporate region with a large workforce requiring structured and dependable monthly transport services."
  }
],


"services": [
{
"name": "Monthly Cab Service Pune",
"description": "eTravo offers reliable monthly cab service in Pune designed for individuals and businesses seeking consistent daily transportation. Our service ensures punctual pickups, comfortable rides, and dedicated vehicles, making daily commuting stress-free and efficient."
},
{
"name": "Monthly Pickup Drop Pune",
"description": "Our monthly pickup and drop service in Pune is perfect for daily commuters and employees. eTravo provides fixed schedules, trained drivers, and safe travel, ensuring timely arrivals and smooth daily routines."
},
{
"name": "Office Monthly Cab Pune",
"description": "Simplify office commuting with eTravo’s office monthly cab services in Pune. We offer dedicated vehicles for employees, ensuring consistent and reliable travel between home and workplace with complete comfort."
},
{
"name": "Employee Transport Monthly Pune",
"description": "eTravo provides monthly employee transport services in Pune for companies of all sizes. Our well-planned routes and punctual services ensure safe and efficient workforce mobility every day."
},
{
"name": "Monthly Taxi Hire Pune",
"description": "Choose eTravo’s monthly taxi hire in Pune for flexible and cost-effective transportation. Our service is ideal for individuals and businesses needing daily travel with consistent quality and professional drivers."
},
{
"name": "Staff Pickup Drop Pune",
"description": "eTravo offers dependable staff pickup and drop services in Pune on a monthly basis. We ensure timely scheduling, safe rides, and smooth coordination for employee transportation across the city."
},
{
"name": "Monthly Office Transport Pune",
"description": "Our monthly office transport services in Pune are designed to streamline daily employee commuting. eTravo ensures reliable vehicles, trained drivers, and efficient route management for smooth operations."
},
{
"name": "Subscription Cab Pune",
"description": "eTravo’s subscription cab service in Pune provides a hassle-free monthly travel solution. With fixed plans and dedicated vehicles, customers can enjoy consistent service, cost savings, and reliable daily commuting."
},
{
"name": "Company Monthly Cab Pune",
"description": "eTravo offers company monthly cab services in Pune tailored for corporate travel needs. From employee transport to executive commuting, our services ensure convenience, punctuality, and professional travel experiences."
},
{
"name": "Daily Pickup Drop Monthly Pune",
"description": "Our daily pickup and drop monthly services in Pune provide structured and dependable commuting solutions. eTravo ensures fixed schedules, reliable drivers, and comfortable rides for everyday travel needs."
},
{
"name": "Corporate Monthly Cab Pune",
"description": "eTravo provides corporate monthly cab services in Pune for businesses seeking long-term transport solutions. Our service ensures consistent quality, efficient operations, and reliable travel for employees and executives."
},
{
"name": "Fixed Route Cab Pune",
"description": "eTravo offers fixed route cab services in Pune for regular commuters and companies. Our predefined routes ensure timely pickups and drops, making daily travel predictable, efficient, and convenient."
},
{
"name": "Monthly Travel Service Pune",
"description": "Our monthly travel services in Pune are ideal for individuals and businesses requiring regular transportation. eTravo ensures comfort, punctuality, and smooth travel experiences throughout the month."
},
{
"name": "Employee Commute Service Pune",
"description": "eTravo’s employee commute services in Pune focus on safe and efficient daily travel. We provide reliable transportation solutions that improve employee convenience and help companies maintain productivity."
},
{
"name": "Monthly Cab Booking Pune",
"description": "eTravo makes monthly cab booking in Pune simple and convenient. With flexible plans, dedicated vehicles, and professional drivers, our service ensures a seamless commuting experience for long-term travel needs."
}
],
"tableData": [
["Monthly Cab Service Pune", "Monthly Pickup Drop Pune"],
["Office Monthly Cab Pune", "Employee Transport Monthly Pune"],
["Monthly Taxi Hire Pune", "Staff Pickup Drop Pune"],
["Monthly Office Transport Pune", "Subscription Cab Pune"],
["Company Monthly Cab Pune", "Daily Pickup Drop Monthly Pune"],
["Corporate Monthly Cab Pune", "Fixed Route Cab Pune"],
["Monthly Travel Service Pune", "Employee Commute Service Pune"],
["Monthly Cab Booking Pune", ""]
]
,





"whychoose": [
    {
      "WhyChooseheading": "Reliable Monthly Pick and Drop Service in Pune",
      "WhyChoosedescription": "eTravo offers dependable monthly pick and drop service in Pune, designed for employees and corporate professionals who need consistent, hassle-free daily commuting solutions across the city."
    },
    {
      "WhyChooseheading": "Perfect for Daily Office Commute",
      "WhyChoosedescription": "Our monthly plans are ideal for office-goers, ensuring fixed pickup and drop timings that eliminate daily travel stress and improve work-life balance."
    },
    {
      "WhyChooseheading": "Customized Routes and Flexible Timings",
      "WhyChoosedescription": "We provide fully customizable routes and schedules, allowing companies and individuals to choose convenient pickup points, timings, and destinations." 
    },
    {
      "WhyChooseheading": "Cost-Effective Monthly Packages",
      "WhyChoosedescription": "Monthly cab services are more economical compared to daily bookings, helping businesses and individuals save significantly on regular travel expenses." 
    },
    {
      "WhyChooseheading": "Professional Drivers with Local Expertise",
      "WhyChoosedescription": "Our experienced chauffeurs ensure safe and smooth travel with strong knowledge of Pune routes, minimizing delays caused by traffic or route changes." 
    },
    {
      "WhyChooseheading": "Safe, Comfortable, and AC Vehicles",
      "WhyChoosedescription": "All vehicles are clean, sanitized, and well-maintained, offering a comfortable and secure commuting experience for daily travelers." 
    },
    {
      "WhyChooseheading": "Real-Time Tracking and Safety Assurance",
      "WhyChoosedescription": "We provide GPS-enabled tracking and safety measures to ensure complete visibility and peace of mind for employees and companies." 
    },
    {
      "WhyChooseheading": "24/7 Support for Daily Commute Needs",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to handle schedule changes, route updates, and emergency travel requirements." 
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is a monthly pick and drop service in Pune?',
            answer: 'A monthly pick and drop service in Pune is a subscription-based cab service that provides daily transportation between home and office with fixed schedules and routes.',
        },
        {
            question: 'Who should use monthly pickup and drop services?',
            answer: 'This service is ideal for office employees, corporate teams, and professionals who need regular daily commuting without relying on public transport.',
        },
        {
            question: 'Are monthly cab services available for corporate employees in Pune?',
            answer: 'Yes, many providers offer corporate-focused monthly cab services designed for employee transport and office commute solutions. :contentReference[oaicite:0]{index=0}',
        },
        {
            question: 'Can I customize pickup and drop timings?',
            answer: 'Yes, most monthly cab services allow flexible scheduling and route customization based on user or company requirements.',
        },
        {
            question: 'Is monthly pick and drop service cost-effective?',
            answer: 'Yes, monthly packages are generally more affordable than booking daily rides, making them a cost-efficient commuting option.',
        },
        {
            question: 'Do monthly cab services include safety features?',
            answer: 'Yes, services typically include GPS tracking, verified drivers, and safety protocols for secure daily travel.',
        },
        {
            question: 'Can companies book bulk employee transport services?',
            answer: 'Yes, businesses can book bulk monthly cab services for employees with route planning and scheduling support. :contentReference[oaicite:1]{index=1}',
        },
        {
            question: 'Are vehicles available for different group sizes?',
            answer: 'Yes, fleets usually include sedans, SUVs, and larger vehicles depending on the number of passengers and travel needs.',
        },
        {
            question: 'Is the service available for multiple shifts?',
            answer: 'Yes, monthly pick and drop services support day, night, and rotational shifts for corporate employees. :contentReference[oaicite:2]{index=2}',
        },
        {
            question: 'How can I book monthly pick and drop service in Pune?',
            answer: 'You can book through online platforms or directly contact service providers to choose a suitable monthly plan based on your commute needs.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Deshpande',
        designation: 'Software Engineer, IT Park Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s monthly pick and drop service in Pune has made my daily commute stress-free. The punctual service and comfortable cars are perfect for office travel.”',
    },
    {
        name: 'Ms. Kavita Sharma',
        designation: 'HR Executive, Kharadi Business Hub',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for employee transportation, and their monthly service is highly reliable. It has improved punctuality and convenience for our entire team.”',
    },
];











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Pick and Drop Service Pune",
  "image": "https://www.etravo.in/images/keyword/monthly-pick-drop-pune.jpg",
  "description": "Affordable monthly pick and drop service in Pune by eTravo. Ideal for office commute, employee transport, fixed route cab services, and subscription-based daily travel with reliable and comfortable rides.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/monthly-pick-and-drop-service-pune"
  }
};







    return (
        <div>


<Helmet>
  <title>Monthly Pick and Drop Service Pune | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book monthly pick and drop service in Pune with eTravo for office commute, employee transport, fixed route cab services, and daily travel needs. Reliable subscription cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/125.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlypickanddropservice;